const { instance } = require('./url')

async function getSchedule(id) {
    return await instance.get('/schedule/' + id)
}

async function insertSchedules(schedules, id) {
    return await instance.post('/schedule/' + id, {
        'schedules': schedules
    })
}

async function deleteSchedules(id) {
    return await instance.delete('/schedule/' + id)
}

async function updateSchedule(prevSchedules, schedules, id) {
    const deleteIds   = prevSchedules.filter((prev) => !schedules.find((newSchedule) => prev.id === newSchedule.id)).map((x) => x.id)
    const newSchedule = schedules.filter((newSchedule) => !prevSchedules.find((prev) => prev.id === newSchedule.id))
    const failures = []

    for (let i = 0; i < deleteIds.length; i++) {
        const responseDeletedSchedule = await deleteSchedules(deleteIds[i])
    }
    if (newSchedule.length > 0) {
        const responseInsertSchedule = await insertSchedules(newSchedule, id)
    }


    for (let i = 0; i < prevSchedules.length; i++) {
        if (!prevSchedules[i].id) {
            continue
        }
        const newSchedule = schedules.find((x) => x.id === prevSchedules[i].id)
        if (!newSchedule) {
            continue
        }

        let changedSchedule = {id: prevSchedules[i].id}
        for (let key in prevSchedules[i]) {
            if (['human_expected_duration_minutes'].indexOf(key) !== -1) {
                if (prevSchedules[i][key] != newSchedule[key]) {
                    changedSchedule[key] = newSchedule[key]
                }
            }
            else if (key === 'dependency' || key === 'materials') {
                if (JSON.stringify(prevSchedules[i][key]) !== JSON.stringify(newSchedule[key])) {
                    changedSchedule[key] = newSchedule[key]
                }
            }
            else if (key === 'sign_ids') {
                const prevIds = [...(prevSchedules[i][key] || [])].sort()
                const newIds = [...(newSchedule[key] || [])].sort()
                if (JSON.stringify(prevIds) !== JSON.stringify(newIds)) {
                    changedSchedule[key] = newSchedule[key]
                }
            }
            else if (key === 'start_time' || key === 'end_time') {
                const prevTime = prevSchedules[i][key] ? new Date(prevSchedules[i][key]).getTime() : null
                const newTime = newSchedule[key] ? new Date(newSchedule[key]).getTime() : null
                if (prevTime !== newTime) {
                    changedSchedule[key] = newSchedule[key]
                }
            }
            else if (prevSchedules[i][key] !== newSchedule[key]) {
                changedSchedule[key] = newSchedule[key]
            }
        }

        if (Object.keys(changedSchedule).length > 1) {
            try {
                const responseUpdateSchedule = await updateDailyScheduleWithBody(changedSchedule.id, changedSchedule)
            } catch (error) {
                failures.push({id: changedSchedule.id, error})
            }
        }
    }

    return failures
}

async function getAssignTo() {
    return await instance.get('/schedule/assign_to', { })
}

function getSortedAssignTo(assignToItems, equip) {
    assignToItems = assignToItems.sort((lhs, rhs) => {

        if (lhs.equip === equip && rhs.equip === equip) {
            return rhs.count - lhs.count
        }

        if (lhs.equip === equip) {
            return -1
        }

        if (rhs.equip === equip) {
            return 1
        }

        return rhs.count - lhs.count
    })

    assignToItems = assignToItems
        .map((x) => x.assign_to)
        .filter((value, index, self) => self.indexOf(value) === index)

    return assignToItems
}


// MARK: Daily Schedule

/**
 * Takes the daily schedule's search_object directly - anything omitted
 * defaults to 'All', so a caller only names the filters it cares about.
 * @param {{search_task, completion, assign_to, production_state, pm, team,
 *     sign_type}} searchObject
 */
async function getDailySchedule(searchObject={}) {
    return await instance.post(
        '/dailyschedule',
        {
            'equip': searchObject.search_task || 'All',
            'assign_to': searchObject.assign_to || 'All',
            'completion': searchObject.completion || 'All',
            'production_state': searchObject.production_state || 'All',
            'pm': searchObject.pm || 'All',
            // ?? not || - '' is the "unassigned" filter, not a missing one.
            'team': searchObject.team ?? 'All',
            'sign_type': searchObject.sign_type || 'All',
        },
    )
}

async function updateDailyScheduleWithBody(id, body) {
    return await instance.put('/dailyschedule/' + id, body)
}


// MARK: Production

async function getReadyForProduction() {
    return await instance.get('/production/ready')
}

async function getReleasedForProduction() {
    return await instance.get('/production/released')
}


async function getCapacityStats() {
    return await instance.get('/schedule/capacity')
}

async function getInProgressTasks() {
    return await instance.get('/schedule/inprogress')
}

async function getEmployeeWeeklyStats() {
    return await instance.get('/schedule/employeestats')
}

async function getDailyScheduleDependency() {
    return await instance.get('/dailyschedule/dependency')
}

async function getWipStats() {
    return await instance.get('/schedule/wip')
}

async function getPaintColorCount() {
    return await instance.get('/schedule/paintcolorcount')
}

async function getTodaysScheduleByEquip() {
    return await instance.get('/schedule/todaybyequip')
}

async function getQueuedScheduleByEquip() {
    return await instance.get('/schedule/queuedbyequip')
}

export {
    getSchedule, updateSchedule,
    insertSchedules,
    deleteSchedules,
    getSortedAssignTo,
    getAssignTo,
    getDailySchedule,
    getDailyScheduleDependency,
    updateDailyScheduleWithBody,
    getReadyForProduction, getReleasedForProduction,
    getCapacityStats, getInProgressTasks, getEmployeeWeeklyStats,
    getWipStats, getPaintColorCount, getTodaysScheduleByEquip,
    getQueuedScheduleByEquip,
}
